import React from "react";
import styled from "styled-components";

/**
 * 会社概要ページの読みものセクション（PROFILE）。
 * - 見出しは /careers「募集職種」と同じ（中央寄せの heading-spacing-2140 + bodytext-13 の英語サブタイトル）
 * - 見出しブロックは .u-wrapper と同じ 1140px 幅、本文は max-width 640px で中央寄せ
 */
export interface AboutSectionProps {
  /** 日本語の見出し（例: 会社概要） */
  title: string;
  /** 英語のサブタイトル（例: PROFILE） */
  subtitle?: string;
  children: React.ReactNode;
}

const Section = styled.section.attrs({
  className: "u-w100 u-col u-items-center",
})`
  padding: 96px 24px 128px;

  @media (max-width: 767px) {
    padding: 64px 24px 96px;
  }
`;

const Inner = styled.div.attrs({
  className: "u-w100 u-col u-items-center u-gap32",
})`
  max-width: 1140px;
`;

const Body = styled.div.attrs({
  className: "u-w100 u-col",
})`
  max-width: 640px;
`;

/* Careers.tsx の JobsSectionTitle / JobsSectionSubtitle と同じ */
const Title = styled.h2.attrs({
  className: "heading-spacing-2140",
})`
  text-align: center;
  margin-bottom: 16px;
  color: #333;
`;

const Subtitle = styled.p.attrs({
  className: "bodytext-13",
})`
  text-align: center;
  color: #666;
  text-transform: uppercase;
`;

const Heading = styled.div.attrs({ className: "u-w100 u-col u-items-center" })`
  margin-bottom: 16px;
`;

const AboutSection: React.FC<AboutSectionProps> = ({ title, subtitle, children }) => {
  return (
    <Section>
      <Inner>
        <Heading>
          <Title>{title}</Title>
          {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
        </Heading>
        <Body>{children}</Body>
      </Inner>
    </Section>
  );
};

export default AboutSection;
